import React from "react";
import { Block, BlockContent, BlockDes, BlockHead, BlockTitle } from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link, useHistory } from "react-router-dom";
import {useDispatch} from 'react-redux';
import { QueryClient, QueryClientProvider, useQuery, useMutation } from "@tanstack/react-query";
import { loginAxios } from '../../config/axios.config';
import { Spinner, Button } from "reactstrap";
const Success = (props) => {

  const history = useHistory();
  const dispatch = useDispatch();

  var url = new URL(window.location.href);
  var v_link = url.searchParams.get("v_link");
  
  const verifyUser = async () => {
    try {
      const { data } = await loginAxios.get(`designers/verify?v_link=${v_link}`);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const { isFetching, isLoading, error, isSuccess, isError, data } = useQuery(['verifyUser'], verifyUser, {
    cacheTime: 0,
  })

  if(isSuccess) {
    dispatch({ type: 'REGISTER_SUCCESS_MESSAGE', payload: 'Verification successful. Please login' })
    history.push('/auth-login')
  }


  return (
    <React.Fragment>
      <Head title="Success" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body">
          <div className="brand-logo pb-5">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>

          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Error occured.</BlockTitle>
              <BlockDes className="text-danger">
                <p>Restart Verification Process</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          <Link to={process.env.PUBLIC_URL + "/auth-register"}>
            <Button color="primary" size="md">
              Request Verification Link
            </Button>
          </Link>
        </Block>
        {/* <AuthFooter /> */}
      </PageContainer>
    </React.Fragment>
  )
};
export default Success;
